import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { JEService } from 'src/app/services/je-services.service';
import { first } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DashboardService } from 'src/app/services/dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import saveAs from 'file-saver';
@Component({
  selector: 'app-tank-stage3',
  templateUrl: './tank-stage3.component.html',
  styleUrls: ['./tank-stage3.component.scss']
})
export class TankStage3Component implements OnInit {

  @ViewChild('appVerificationTable', { static: true }) public appVerificationTable: Table;
  userId: any;
  application: any;
  public tankData: any;
  displayTankDialog : boolean = false;
  selectedApplication: any;
  pondVerData: any;
  selectedStatus: any;
  remarks: any;
  items: any[];
  actualSubsidyStage3 : string;
  isSubmitted: boolean = false;

  ipAddress: any = '000.000.000';
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  appVerificationItems:MenuItem[];
  appVerificationModel:any[];
  
  public loading: boolean = false;
  public subscriptions: any = [];


  constructor(private messageService: MessageService,
    private pondService: JEService,
    private tokenService: TokenService,
    private deptDashBoardService: DepartmentDashboardService, public router: Router, private dashboard: DashboardService, private ipService: IpAddressService, private activityRecordService: ActivityRecordService,private loader: AppLoaderService) { }

  ngOnInit(): void {
    this.getIP();
    this.loadData();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Tank_Stage_export');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Tank_Stage_export'
          );
        },
      },
    ];
    this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  getStatusItems(){
    // let actionId = 31; // Do not Change,
    let actionId = 25; // Do not Change,
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
    .pipe(first())
    .subscribe({
      next: (data) => {
        this.loader.close();
        this.items = data.$values;
      },
      error: () => {
        this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
      }
    });
  }

  loadData() {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // this.loader.start();
    this.loading = true;
    let sub = this.pondService
      .GetFarmerAppForPondVer_SubsidyCalc_Stage3(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-3 Survey', '', new Date(), 'Success');

          this.tankData = data;
          // this.loader.close();
          this.loading = false;
          this.getStatusItems();
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-3 Survey', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  refreshTable() {
    this.loadData();
    this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'App type': d.FarmerName,
          'District': d.District,
          'block': d.Block,
          "Village": d.Village,
          'Total Area': d.Total_Area,
          'Age Of Application': d.AgeOfApplication,
          'Pending Completed Days': d.PendingCompletedDays,
          'Land Detail': d.LandDetail,
          'status': d.Status,
          'Current Status': d.Status_Ar,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'District', header: 'district' },
      { field: 'Block', header: 'block' },
      { field: 'Village', header: 'village' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Status', header: 'Status' },
      { field: 'Status_Ar', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  selectTankRowData(application){
    this.displayTankDialog = true;
    this.selectedApplication = application;
    if(application.appID){
      this.pondService
      .getPondVerDataByAppId_SubsidyCalc_Stage3(application.appID)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.pondVerData = res;
        },
        error: (err) => {
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  onCloseDialog(){
    this.displayTankDialog = false;
    this.remarks=''
  }

  viewFarmerApplication(application) {
    if(application.appID){
      const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', application.appID]));
      window.open(link, '_blank');
      // this.dashboard
      // .getMIDetailByAppID(application.appID)
      // .pipe(first())
      // .subscribe({
      //   next: (res) => {
      //     const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', application.appID, ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
      //     window.open(link, '_blank');
      //   },
      //   error: (err) => {
      //     console.log("error", err);
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error Message',
      //       detail: err,
      //     });
      //   },
      // });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  handleClick(){
    this.isSubmitted = true;
    if(!this.actualSubsidyStage3){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Actual Subsidy Stage 3 Cannot be empty.',
      });
      return;
    }
    let body = {
      appID: this.selectedApplication?.appID,
      miSurvey_ID: this.pondVerData?.MISurveyID,
      actualSubsidy_Stage3: parseFloat(this.actualSubsidyStage3),
      stateShare_Amount: this.pondVerData?.StateShare_Amount,
      centerShare_Amount: this.pondVerData?.CenterShare_Amount,
      userID: this.userId,
      remarks: this.remarks ? this.remarks : '',
      status: this.selectedStatus?.flag,
      networkId: this.ipAddress,
      terminalId: this.ipAddress
    }
    this.loader.start();
    this.pondService
      .insertPondSurvey_SubsidyCalc_Stage3(body)
      .pipe(first())
      .subscribe({
        next: (data) => {
          let index=this.tankData.findIndex(e=>{return e.appID==body.appID})
          let index1=this.appVerificationTable.filteredValue.findIndex(e=>{return e.appID==body.appID})
          this.tankData.splice(index,1)
          this.appVerificationTable.filteredValue.splice(index1,1)
          this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: data.toString(),
          });
          this.onCloseDialog();
          this.loader.close();
          // this.loadData();
         
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Dashboard not loaded.',
          });
        },
      });
  }
  rowBackgroundColor(product){
    if(product.Status_Ar == 'P'){
      if(product.Pending_CompletedDays <= -2){
        return '#ff8080';
      }
      else if(product.Pending_CompletedDays == -1){
        return '#ffc966';
      }
    }
    else if(product.Status_Ar == 'C' || product.Status_Ar == 'A'){
      if(product.Pending_CompletedDays >= -1){
        return '#99e699';
      }
      else if(product.Pending_CompletedDays <= -2){
        return '#ffb3b3';
      }
    }
    else
      return '#ffffff';
  }



}
